/*
  bf_turnreplay.ts
  Copyright (c) 2013-present Human Cube Inc.

  Replay adding functions.  Must all be synchronous and not involve any external DB or file access.
  Also does not access any external user data.
  These restrictions are to allow it to be re-used in other environments such as the client.
*/

import { Game } from '../gameTypes';


const bf_turnreplay = {

  pickZone: function (game: Game, playerIndex: number, zoneID: number) {
    if( !game.replay.pickZone )
      game.replay.pickZone = [];
    game.replay.pickZone.push([playerIndex, zoneID]);
  },

  pickCapital: function (game: Game, playerIndex: number, zoneID: number, x: number, y: number) {
    if( !game.replay.pickCapital )
      game.replay.pickCapital = [];
    game.replay.pickCapital.push([playerIndex, zoneID, x, y]);
  },

  arrange: function (game: Game, forceID: number, x: number, y: number) {
    if( !game.replay.arrange )
      game.replay.arrange = [];
    game.replay.arrange.push([forceID, x, y]);
  },

  retreat: function (game: Game, forceID: number, zoneID: number, x: number, y: number) {
    if(!game.replay.retreat)
      game.replay.retreat = [];
    // Remember there are some old game cores that have just the forceID:
    // game.replay.retreat.push(forceID);
    // This has been changed for if the force is destroyed, the retreat destination zoneID was previously lost.
    game.replay.retreat.push([forceID, zoneID, x, y]);
  },

  move: function (
    game: Game, moveCycle: number, forceID: number, zoneID: number, x: number, y: number,
  ) {
    if(!game.replay.move)
      game.replay.move = [];
    for(var i = 0; i <= moveCycle; i++)
      if(!game.replay.move[i])
        game.replay.move[i] = [];
    game.replay.move[moveCycle].push([forceID, zoneID, x, y]);
  },

  moveBlocked: function (
    game: Game, moveCycle: number, forceID: number, fromZoneID: number, toZoneID: number,
  ) {
    if(!game.replay.moveBlocked)
      game.replay.moveBlocked = [];
    for(var i = 0; i <= moveCycle; i++)
      if(!game.replay.moveBlocked[i])
        game.replay.moveBlocked[i] = [];
    game.replay.moveBlocked[moveCycle].push([forceID, fromZoneID, toZoneID]);
  },

  loadBlocked: function (
    game: Game, moveCycle: number, cargoID: number, forceID: number,
    fromZoneID: number, toZoneID: number,
  ) {
    if(!game.replay.loadBlocked)
      game.replay.loadBlocked = [];
    for(var i = 0; i <= moveCycle; i++)
      if(!game.replay.loadBlocked[i])
        game.replay.loadBlocked[i] = [];
    game.replay.loadBlocked[moveCycle].push([cargoID, forceID, fromZoneID, toZoneID]);
  },

  unloadBlocked: function (
    game: Game, moveCycle: number, forceID: number, cargoID: number,
    fromZoneID: number, toZoneID: number,
  ) {
    if(!game.replay.unloadBlocked)
        game.replay.unloadBlocked = [];
    for(var i = 0; i <= moveCycle; i++)
      if(!game.replay.unloadBlocked[i])
        game.replay.unloadBlocked[i] = [];
    game.replay.unloadBlocked[moveCycle].push([forceID, cargoID, fromZoneID, toZoneID]);
  },

    hit: function (game: Game, forceID: number, shooterID: number) {
        if(!game.replay.hit)
            game.replay.hit = [];
        game.replay.hit.push([forceID, shooterID]);
    },

    land: function (game: Game, forceID: number) {
        if(!game.replay.land)
            game.replay.land = [];
        game.replay.land.push(forceID);
    },

    crash: function (game: Game, forceID: number) {
        if(!game.replay.crash)
            game.replay.crash = [];
        game.replay.crash.push(forceID);
    },

    splash: function (game: Game, forceID: number) {
        if( !game.replay.splash )
            game.replay.splash = [];
        game.replay.splash.push(forceID);
    },

    eliminate: function (game: Game, playerID: number) {
        if( !game.replay.eliminate )
            game.replay.eliminate = [];
        game.replay.eliminate.push(playerID);
    },

    wipe: function (game: Game, forceID: number) {
        // Player force is destroyed.  Possibly when eliminated.
        if( !game.replay.wipe )
            game.replay.wipe = [];
        game.replay.wipe.push(forceID);
    },

    lose: function (game: Game, zoneID: number) {
        // Player loses control of a zone.  Possibly when eliminated.
        if( !game.replay.lose )
            game.replay.lose = [];
        game.replay.lose.push(zoneID);
    },

    takeover: function (game: Game, zoneID: number) {
        // The owner of a zone is changed.
        if( !game.replay.takeover )
            game.replay.takeover = [];
        game.replay.takeover.push(zoneID);
    },

    capture: function (game: Game, forceID: number, oldOwner: number, newOwner: number) {
        // The player owner of a force is changed.
        if( !game.replay.capture )
            game.replay.capture = [];
        game.replay.capture.push([forceID, oldOwner, newOwner]);
    },

    purchase: function (game: Game, forceID: number) {
        if( !game.replay.purchase )
            game.replay.purchase = [];
        game.replay.purchase.push(forceID);
    },

    alreadyExists: function (game: Game, playerIndex: number, zoneID: number, forceType: number) {
        if(!game.replay.alreadyExists)
            game.replay.alreadyExists = [];
        game.replay.alreadyExists.push([playerIndex, zoneID, forceType]);
    },

    blockaid: function (game: Game, playerIndex: number, zoneID: number, forceType: number) {
        if(!game.replay.blockaid)
            game.replay.blockaid = [];
        game.replay.blockaid.push([playerIndex, zoneID, forceType]);
    },

  cannotBuild: function (game: Game, playerIndex: number, zoneID: number, forceType: number) {
    if(!game.replay.cannotBuild)
      game.replay.cannotBuild = [];
    game.replay.cannotBuild.push([playerIndex, zoneID, forceType]);
  },

  victory: function (game: Game, winners: number[], winningTeams: false | number, reason: number) {
    game.replay.victory = {
      winner: winners,
      reason,
    };
    if( winningTeams !== false ) {
      game.replay.victory.winningTeam = winningTeams;
    }
  },

};


export default bf_turnreplay;
